<div class="main-content">
  <section class="access">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <ul class="step">
            <li><span [class.en]="state.member.translate === 'en'">{{ 'selectAGymBranch' | translate }}</span></li>
            <li><span [class.en]="state.member.translate === 'en'">{{ 'enterYourDetails' | translate }}</span></li>
            <li><span>{{ 'confirm' | translate }}</span></li>
            <li class="active"><span>{{ 'complete' | translate }}</span></li>
          </ul>
          <div class="clearfix"></div>

          @if (state.showProcess) {
            <div>
              <h1>お申し込みを処理しています...</h1>
              <br />
              <p>画面を閉じずに、このまましばらくお待ちください。</p>
            </div>
          }

          @if (workflow.message) {
            <div class="alert alert-warning registration-unknown" role="alert">
              <h2>お申し込み結果の確認が必要です</h2>
              <p>{{ workflow.message }}</p>
              @if (workflow.unknown && !workflow.busy) {
                <label><input type="checkbox" [(ngModel)]="outcomeChecked" name="outcomeChecked"> 店舗等に確認し、新たな手続きが必要なことを確認しました</label>
                <button type="button" class="btn btn-default" [disabled]="!outcomeChecked" (click)="acknowledgeOutcome()">確認済みとして新しい入力へ進む</button>
              }
            </div>
          }

          @if (state.showFailed) {
            <div>
              <h2 class="error">お申し込み処理中にエラーが発生しました</h2>
              <br />
              <p class="error">トップに戻って再度お手続きください。</p>
            </div>
          }

          @if (state.showSuccess) {
            <div>
              <h1>{{ 'registrationAccepted' | translate }}</h1>
              <br />
              @if (state.gmoCreateError) {
                <p class="error">クレジットカードの登録でエラーが発生しました。店舗で再登録してください。</p>
              }
              @if (workflow.imageWarning) {
                <p class="error registration-image-warning" role="alert">会員登録は完了しましたが、本人確認画像の送信を完了できませんでした。画像は店舗へご提出ください。再申込は不要です。</p>
              }
              @if (state.emailSent) {
                <p>{{ 'emailConfirmationMsg' | translate }}</p>
              }
            </div>
          }

          <br />
          <div class="text-center">
            @if (canShowBtRegistration) {
              <form method="POST" [action]="btPostUrl" accept-charset="Windows-31J">
                @for (btPostValue of btPostValues; track btPostValue.key) {
                  <input type="hidden" [name]="btPostValue.key" [value]="btPostValue.value">
                }
                <button class="btn-application-1" style="margin-bottom: 0; margin-top: 2rem;" type="submit" value="送信">続けてお支払口座を登録する</button>
              </form>
            }
            <button class="btn-application-1" (click)="goToTop()">{{ 'backToTop' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
